import { BackgroundImage } from "./BackgroundImage";
import React from "react";
import { getScreenType, SCREEN_WIDTH } from "../helpers/layout";

export function BodyItem({ image, name, cover = true }) {
  const isSmallScreen = getScreenType() === SCREEN_WIDTH.COMPACT;
  return (
    <>
      <div style={{ width: "100%", height: isSmallScreen ? 200 : 400, backgroundColor: "#fff", borderRadius: 8 }}>
        <BackgroundImage
          type={cover === true ? 'cover' : 'contain'}
          // type={"contain"}
          title={name} source={image}
          style={{ width: "100%", height: isSmallScreen ? 150 : 350 }} />
        {/*<img alt={name} style={{width: '100%', borderRadius: 10}} src={image}/>*/}
      </div>
      <div style={{ height: 24 }} />
    </>
  );
}
